<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice PAI</label>
                        <b-form-input v-model="filtro.idPai" type="search" placeholder="idPai"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Accesso</label>
                        <b-form-input v-model="filtro.codiceAccesso" type="search" placeholder="Codice accesso"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stato</label>
                        <b-form-select v-model="filtro.stato" :options="opzioniStato"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Reset Filtro</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(idPai)="{ item }">#{{ item.idPai }} / {{ item.idPei }}</template>
                    <template v-slot:cell(stato)="{ item }">
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (item.stato === 'ACCETTATA' ? 'aperta' : 'da-programmare')">{{ item.stato }}</span>
                    </template>
                    <template v-slot:cell(periodo)="{ item }">{{ formatDateTime(item.dataOraInizio) }} - {{ formatDateTime(item.dataOraFine) }}</template>
                    <template v-slot:cell(messaggioEsito)="{ item }">
                        <span :title="item.messaggioEsito">{{ item.messaggioEsito && item.messaggioEsito.length > 60 ? item.messaggioEsito.substring(0, 60) + "..." : item.messaggioEsito }}</span>
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <router-link :to="'/andiamo/pai/' + item.idPai" class="btn btn-sm btn-outline-secondary">
                            <i class="fas fa-eye"></i>
                            Vai al PAI
                        </router-link>
                    </template>
                </b-table>
            </div>
            <no-data-component v-if="!items.length" title="Nessuna erogazione inviata trovata" :fontSize="15" :paddingSize="0.5" />
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AndiamoMixin from "../mixins/AndiamoMixin";

export default {
    components: { SaPageLayout, NoDataComponent },
    mixins: [UtilityMixin, AndiamoMixin],
    data() {
        return {
            rows: 0,
            perPage: 20,
            currentPage: 1,
            showModalLoading: false,
            items: [],
            opzioniStato: [
                { value: null, text: "Tutti" },
                { value: "ACCETTATA", text: "ACCETTATA" },
                { value: "RIFIUTATA", text: "RIFIUTATA" },
            ],
            filtro: { idPai: null, codiceAccesso: null, stato: null },
            fields: [
                { label: "PAI / PEI", key: "idPai" },
                { label: "Codice Accesso", key: "codiceAccesso" },
                { label: "Periodo", key: "periodo" },
                { label: "Operatore", key: "codiceFiscaleOperatore" },
                { label: "Stato", key: "stato" },
                { label: "Esito", key: "messaggioEsito" },
                { label: "", key: "actions", tdClass: "sa-table-column-action-double" },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoErogazioniLocaliPathResource;
            let params = { ...me.filtro, page: me.currentPage, forPage: me.perPage };
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.items = response.data.data.list || [];
                    me.rows = response.data.data.recordsNumber || 0;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onSubmit() {
            this.currentPage = 1;
            this.loadData();
        },
        onReset() {
            this.filtro = { idPai: null, codiceAccesso: null, stato: null };
            this.currentPage = 1;
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
    },
};
</script>

<style scoped>
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
